<!-- show-outstanding-documents.component.html -->
<p-card
    *ngIf="outstandingDocuments"
    class="w-full flex:1"
    [header]="'Pending '.concat(identifier).concat(' Documents') | translate"
>
    <p-messages [(value)]="messages" [closable]="true" />
    <div *ngFor="let document of outstandingDocuments" class="mb-3">
        <form
            class="document-container px-4 py-4 border-200 radius-2 border-1"
            [formGroup]="documentForm"
            enctype="multipart/form-data"
        >
            <span
                class="document-title text-700 text-1xl font-bold text-color-primary font-semibold"
            >
                {{ document.name | translate }}
            </span>
            <span
                class="pi pi-question-circle"
                pTooltip="{{ document.name | translate }}"
            ></span>

            <div
                class="input-container mb-2 mt-2 w-20rem"
                formGroupName="documentMetadata"
            >
                <span
                    class="p-input-icon-left w-full pb-3"
                    *ngIf="document.requiresIdentifier"
                >
                    <input
                        id="documentNumber"
                        type="text"
                        pInputText
                        class="w-full"
                        [placeholder]="translateText(document.identifierName)"
                        formControlName="documentIdentifier"
                    />
                </span>
                <span
                    class="p-input-icon-left w-full"
                    *ngIf="document.requiresExpiryDate"
                >
                    <p-calendar
                        id="dob"
                        [showIcon]="true"
                        [iconDisplay]="'input'"
                        formControlName="expiryDate"
                        [placeholder]="'EXPIRY_DATE' | translate"
                        styleClass="w-full"
                        [inputStyle]="{ paddingLeft: '2.5rem' }"
                        inputStyleClass="w-full p-input-icon-left"
                    ></p-calendar>
                </span>
            </div>
            <p-fileUpload
                name="myfile[]"
                mode="advanced"
                (onSelect)="onFileSelect($event, document)"
                (onUpload)="onUpload($event, document)"
                [showCancelButton]="false"
                (onClear)="onFileClear()"
                [customUpload]="true"
                (uploadHandler)="onUpload($event, document)"
                accept=".jpg,.png,.pdf"
                [uploadLabel]="'UPLOAD' | translate"
                [chooseLabel]="'CHOOSE' | translate"
                [cancelLabel]="'CANCEL' | translate"
            >
                <ng-template
                    pTemplate="content"
                    let-files
                    let-uploadedFiles="uploadedFiles"
                >
                    <div *ngIf="files?.length > 0; else noFiles">
                        <h6 class="mb-2 text-500">
                            {{ "FILE_UPLOAD_INSTRUCTION" | translate }}
                        </h6>
                        <div class="flex flex-wrap p-0 gap-5">
                            <div
                                *ngFor="let file of files; let i = index"
                                class="m-0 px-2 flex surface-border align-items-center gap-6"
                            >
                                <span class="font-semibold">{{
                                    file.name
                                }}</span>
                            </div>
                        </div>
                    </div>
                    <ng-template #noFiles>
                        <small style="color: red"
                            >{{ "Max Upload Size" | translate }}: ({{
                                document.maximumPermissibleSize
                            }}MB)</small
                        >
                    </ng-template>
                </ng-template>
                <ng-template pTemplate="file"></ng-template>
            </p-fileUpload>
        </form>
    </div>
</p-card>
